import React from 'react';
import { Heart, Facebook, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_pawsome-care-53/artifacts/bmqpq05g_Logo_Patas_Club2.png" 
                alt="Patas Club Logo" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              {businessInfo.slogan}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('petshop')}
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm"
                >
                  Petshop
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Servicios</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Consultas Veterinarias</li>
              <li>Vacunación</li>
              <li>Desparasitación</li>
              <li>Atención Preventiva</li>
              <li>Petshop</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>{businessInfo.address}</li>
              <li>{businessInfo.city}</li>
              <li>
                <a href={`tel:${businessInfo.phone}`} className="hover:text-teal-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li>{businessInfo.hours}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {businessInfo.name}. Todos los derechos reservados.
            </p>
            
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <span>Hecho con</span>
              <Heart className="w-4 h-4 fill-rose-500 text-rose-500 animate-pulse" />
              <span>para las mascotas</span>
            </div>

            {/* Social Media - Uncomment when ready */}
            {/* <div className="flex items-center gap-4">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;